<template>
    <div style="margin:0 auto;border:1px solid gray;padding: 4px;">
        <div>
            <post-props v-if="apiClient !== null" :item-props="itemProps" :api-client="apiClient"
                v-on:update="updatePropsClick"></post-props>
        </div>

        <hr />

        <div v-if="itemProps !== null && itemProps.length > 0">
            <div style="font-weight:bolder;">{{ lang.postPrices.price }} & {{ lang.postPrices.cost }}  </div>
            <div class="col-xs-12" style="border: 1px solid blue; margin: 2px;">
                <div class="col-xs-12 col-md-6">
                    <div class="col-xs-6 col-md-6" style="text-align: center;">
                        <br />
                        <span style="text-align: center;"> {{lang.postPrices.properties}} </span>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="col-xs-6"> <span class="btn btn-default" style="color:blue;width: 100px;"
                            @click="setAllPrices"> {{ lang.postPrices.set }}
                            {{lang.postPrices.price}} </span>
                        <input type="text" class="form-control" v-model.number="commonPrices.price"
                            style="width: 100px; border: 1px solid black; margin: 2px;">
                    </div>
                    <div class="col-xs-6"> <span class="btn btn-default" style="color:blue;width: 100px;"
                            @click="setAllCosts"> {{ lang.postPrices.set }}
                            {{lang.postPrices.cost}} </span>
                        <input type="text" class="form-control" v-model.number="commonPrices.cost"
                            style="width: 100px; border: 1px solid black; margin: 2px;">
                    </div>
                </div>
            </div>
            <div v-for="(p, index) in itemProps" class="col-xs-12" style="border:1px solid gray;margin:2px;">
                <div class="col-xs-12 col-md-6">
                    <div class="col-xs-6 col-md-6" v-for="cp in p.catPairs" style="text-align: center;">
                        <span style="text-align: center;">
                            {{ cp.child.name }}
                        </span>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6" v-for="price in prices.filter(price => price.propId === p.id)">
                    <div class="col-xs-6">
                        {{ lang.postPrices.price }}:<input v-model="price.price" type="text" class="form-control"
                            style="width:100px;border:1px solid black;margin:2px;" />
                    </div>
                    <div class="col-xs-6">
                        {{ lang.postPrices.cost }}:<input v-model="price.cost" type="text" class="form-control"
                            style="width:100px;border:1px solid black;margin:2px;" />
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <template v-for="price in prices">
                {{ lang.postPrices.price }}:<input v-model="price.price" type="text" style="width:100px;border:1px solid black;margin:2px;" />
                {{ lang.postPrices.cost }}:<input v-model="price.cost" type="text" style="width:100px;border:1px solid black;margin:2px;" />
            </template>
        </div>

        <div class="row">
            <div class="col-xs-12" style="text-align:center;margin-top:10px;">
                <input type="button" @click="updatePriceClick" class="form-control btn btn-primary" :value="lang.postPrices.updatePrices" />
            </div>
        </div>

    </div>
</template>

<script>
import postProps from './postProps.vue';

export default {
    components: {
        postProps
    },
    props: {
        postId:{type:String,default:null},
        apiClient:{type:Object,default:null}        
    },
    computed: {
        lang: function () {
                return this.$store.getters.lang;
        },
    },
    data: function () {
        return {
            commonPrices: { price: 0, cost: 0 },
            prices:[],
            itemProps:null
        }
    },
    methods: {
        updatePriceClick: function () {
            console.log("prices to update", this.prices);
            this.isLoading = true;
            this.apiClient.updatePricePrms(this.postId, this.prices).done((result) => {
                this.isLoading = false;
                if (result.ok === true) {
                    this.prices = result.value;
                    //this.editing.prices = null;
                }
            });
        },
        updatePropsClick: function (propsCatPairsList) {
            var data = propsCatPairsList;
            console.log("propsCatPairsList",data);
            if (data) {
                //var props = this.apiClient.getPostPropObj(data);
                var props = this.getPostPropObj(data);
                var that = this;
                var updateCfr = this.apiClient.updateCfr;
                updateCfr.setMsg("You will need to reset Prices after this,ok?");
                updateCfr.show();
                updateCfr.resetCallback((ok) => {
                    if (ok !== true) return;
                    this.apiClient.addPostPropPrms(props, that.postId).done((result) => {
                        if (result.ok === true) {
                            console.log("addPostPropPrms result.value",result);
                            this.itemProps = result.value;
                            if(this.itemProps===null) this.itemProps=[];
                            this.prices = [];
                            that.initPricesByProps();
                        }
                    });
                });
            }
        },
        getPostPropObj: function (propSets) {
            if (propSets && propSets.length > 0) {
                var ret = [];
                propSets.forEach((item) => {
                    var propset = { "catIds": [], "postId": this.postId, catPairs: item };
                    console.log('item', item);
                    item.forEach((t) => {
                        propset.catIds.push(t.child.catId);
                    });
                    ret.push(propset);
                });
                return ret;
            }
            return [];
        },
        setAllPrices() {
            if (this.prices && this.prices.length > 0) {
                for (var i = 0; i < this.prices.length; i++) {
                    this.prices[i].price = this.commonPrices.price;
                }
            }
        },
        setAllCosts() {
            if (this.prices && this.prices.length > 0) {
                for (var i = 0; i < this.prices.length; i++) {
                    this.prices[i].cost = this.commonPrices.cost;
                }
            }
        },
        loadPriceProps(){
            this.apiClient.getPostPropPricesPrms(this.postId).done((ret) => {
                        var propload = ret.propload;
                        var priceload = ret.priceload;
                        this.itemProps = propload;
                        this.prices = priceload;
                        //this.loadProps();
                        this.initPricesByProps();
                        //this.apiClient.loadingOverlay.hide();
                    });
        },
        initPricesByProps() {
            var pricesLoaded = this.prices;
            var props = this.itemProps;
            console.log("prices and props", prices, props);
            var prices = [];

            var hasProps = props.length > 0;
            if (hasProps) {
                for (var i = 0; i < props.length; i++) {
                    var p = props[i];
                    var propPrice = { propId: p.id, cost: 0, price: 0 };
                    if (pricesLoaded !== null) {
                        var prs = pricesLoaded.filter(pr => pr.propId === p.id)[0];
                        console.log("price matched", prs);
                        if (prs) {
                            propPrice.cost = prs.cost;
                            propPrice.price = prs.price;
                        }
                    };
                    prices.push(propPrice);
                }
            } else {
                console.log('no props,pricesLoaded:', pricesLoaded);
                if (pricesLoaded && pricesLoaded.length > 0) {
                    prices = pricesLoaded;
                } else {
                    prices = [{ propId: null, cost: -1, price: -1 }];
                }
            }
            console.log('final prices', prices);
            this.prices = prices;
        },
    },
    created: function () {
        this.prices = this.itemPrices;
        this.loadPriceProps();
    }
}
</script>
